import React from 'react';
import { observer } from 'mobx-react';
import { Alert, Button, Select, Skeleton, Space, Table, Tag } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { AdminAccountIntegrationsModel } from './AdminAccountIntegrationsModel';
import { Integration } from 'models/Integration';

interface Props {
  model: AdminAccountIntegrationsModel;
}

export const AdminAccountIntegrationsView: React.FC<Props> = observer(({ model }) => {
  if (model.loading && !model.loaded) {
    return <Skeleton active />;
  }

  const columns = [{
    title: 'Name',
    dataIndex: 'name',
    key: 'name'
  }, {
    title: 'Integration ID',
    dataIndex: 'integrationId',
    key: 'integrationId',
    render: (id: string) => <Tag>{id}</Tag>
  }];

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Alert
        type="info"
        showIcon
        message="Pick the DMS integration accounts that should feed Repair Orders and F&I records into this payments account."
        description="Available integrations are loaded from integrations-api. Selecting an integration links it; deselecting unlinks it. Existing invoices are unaffected."
      />

      <Select
        mode="multiple"
        style={{ width: '100%' }}
        placeholder="Select one or more integrations"
        value={model.selected.map(s => s.integrationId)}
        onChange={model.setSelected}
        optionFilterProp="label"
        options={model.available.map(a => ({
          label: `${a.name} (${a.integrationId})`,
          value: a.integrationId
        }))}
      />

      <Table<Integration>
        size="small"
        rowKey={row => row.integrationId}
        columns={columns as any}
        dataSource={model.selected}
        pagination={false}
        locale={{ emptyText: 'No integrations linked yet' }}
      />

      <Button
        type="primary"
        icon={<SaveOutlined />}
        loading={model.saving}
        onClick={model.save}
      >
        Save
      </Button>
    </Space>
  );
});
